<!-- start app-badge -->
<span 
    [style]="style"
    [ngStyle]="{'background-color': bg ? bg : null}"
    class="custom_badge border_r label_sm_bold d-inline-block {{Class ? Class : ''}} {{ClassList ? ClassList : ''}}" 
    >
    {{title}}
</span>
<!-- end app-badge -->